export const state = {
    atividadeCrmProposta: {},
    atividadesCrmProposta: [],
    modalExcluirAtividadeCrmProposta: false,
    modalCadastroAtividadeCrmProposta: false,
}

export default {}